import * as yup from 'yup'

import { getMessage } from '../../../../../../util/IntlMessages'

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .max(60)
    .typeError('must be string')
    .required(getMessage('isRequired', getMessage('name')))
})
